import { graphql } from 'react-relay';
import { useEffect, useState } from 'react';
import { usePageSpaceKey } from '@confluence/page-context';

import type {
	useContentOwnershipSpaceAdminsSpaceAdminsListQuery as useContentOwnershipSpaceAdminsSpaceAdminsListQuery$data,
	useContentOwnershipSpaceAdminsSpaceAdminsListQueryVariables as useContentOwnershipSpaceAdminsSpaceAdminsListQuery$variables,
	useContentOwnershipSpaceAdminsSpaceAdminsListQuery_space_Space_admins as SpaceAdminType,
} from './__types__/useContentOwnershipSpaceAdminsSpaceAdminsListQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
type SpaceAdminsType = SpaceAdminType | null;
export const useContentOwnershipSpaceAdmins = (): SpaceAdminsType[] => {
	const [spaceKey] = usePageSpaceKey();
	const [spaceAdminsList, setSpaceAdminsList] = useState<SpaceAdminsType[]>([]);
	const { data } = useQueryInterop<
		useContentOwnershipSpaceAdminsSpaceAdminsListQuery$data,
		useContentOwnershipSpaceAdminsSpaceAdminsListQuery$variables
	>(
		graphql`
			query useContentOwnershipSpaceAdminsSpaceAdminsListQuery($spaceKey: String!) {
				space(key: $spaceKey) {
					id
					admins(accountType: ATLASSIAN) {
						type
						... on KnownUser {
							email
						}
					}
				}
			}
		`,
		{
			variables: {
				spaceKey: spaceKey!,
			},
			skip: !spaceKey,
		},
	);

	useEffect(() => {
		const spaceAdmins = data?.space?.admins || [];
		setSpaceAdminsList(
			[...spaceAdmins].filter((admin): admin is SpaceAdminsType => admin !== undefined),
		);
	}, [data]);

	return spaceAdminsList;
};
